import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Dropdown,
  Grid,
  Icon,
  Search,
} from "semantic-ui-react";

import cx from "classnames";
import _ from "lodash";

import Users from "../../features/User/Management/List/Users";
import Invitations from "../../features/User/Management/List/Invitations";

import styles from "./iadb.module.scss";
import SortFilter from "components/ui/SortFilter";
import { isAccountSuspended } from "components/features/Util/Util";
import MetaData from "./MetaData";
import CreateMetaData from "./CreateMetaData";

// sort filter dropdown options
const userSortOptions = [
  { key: 0, text: "Name", value: "first_name" },
  { key: 1, text: "Created Date", value: "created_date" },
  { key: 2, text: "Last Active Date", value: "last_activity_date" },
];

const invitationSortOptions = [
  { key: 0, text: "Invited Date", value: "invited_date" },
  { key: 1, text: "Email", value: "email" },
];

export default function IadbInteractive ({ account, setGoBackPath }) {
  const [loading, setLoading] = useState(false);

  const [createMetadataOpen, setCreateMetadataOpen] = useState(false);

  useEffect(() => {
    setGoBackPath("/");
  }, []);

  return (
    <>
      <Container className={cx(styles.container)}>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column className={cx(styles.title)}>
              {account ? account.name : " "}
            </Grid.Column>
            <Grid.Column textAlign="right">
              <Button
                className={cx(styles.btnCreate)}
                onClick={() => setCreateMetadataOpen(!createMetadataOpen)}
                content={
                  <>
                    Create {" "}
                    <span className={cx(styles.icon)}>
                      <Icon name="plus" />
                    </span>
                  </>
                }
                disabled={isAccountSuspended(account)}
              />
            </Grid.Column>
          </Grid.Row>

        </Grid>

        <MetaData
          account={account}
          setLoading={setLoading}
        />

        <CreateMetaData
          account={account}
          open={createMetadataOpen}
          setOpen={setCreateMetadataOpen}
        />
      </Container>
    </>
  );
}

